<app-loading></app-loading>
<div class="container-login" *ngIf="!logueado">
    <app-login></app-login>
</div>


<div class="main-container" *ngIf="logueado">
    <nav class="noimprimir d-flex justify-content-between navbar align-items-center fixed-top" *ngIf="!insertado"><!-- Navbar -->
      <div class="navbar-brand-area d-flex align-items-center">
        <button type="button" class="navbar-sidebar-trigger" (click)="toggleMobileSidebar()" [attr.aria-label]="t.abrirmenu">
          <i class="fa fa-bars"></i>
        </button>
        <!-- <div id="collapse-btn" (click)="collapseSidebar()">
          <span class="mr-5"><i class="fa fa-list"></i></span>
        </div> -->
        <a class="navbar-title" [routerLink]="['/inicio']" >
          <img src="assets/svgs/eamoneLogo.svg" alt="{{t.logoeamone}}" height="40">
        </a>
      </div>

      <div class="navbar-actions d-flex justify-content-end align-items-center">
        <div class="navbar-item">
          <a [routerLink]="['/inicio']" routerLinkActive="router-link-active"  class="navbar-link">
            <i class="fa fa-home"></i>
            <span>{{t.inicio}}</span>
          </a>
        </div>
        <div class="navbar-item mx-2 d-inline">
          <app-language-switcher></app-language-switcher>
        </div>
        <div class="navbar-item dropdown user-menu">
          <a href="" class="user-menu-trigger dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="user-menu-avatar">
              <i class="fa fa-user"></i>
            </span>
            <span class="user-menu-copy">
              <span class="user-menu-label">{{t.usuario}}</span>
              <strong>{{ usuario?.nombre || t.cargando }}</strong>
            </span>
            <i class="fa fa-chevron-down user-menu-chevron"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-right user-menu-dropdown" aria-labelledby="navbarDropdown" >
            <a href="" class="dropdown-item user-menu-item" [routerLink]="['./changepass']">
              <span class="user-menu-item-icon">
                <i class="fa fa-key"></i>
              </span>
              <span>{{t.cambiarclave}}</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="" class="dropdown-item user-menu-item user-menu-item-danger" (click)="onLogout()">
              <span class="user-menu-item-icon">
                <i class="fa fa-sign-out-alt"></i>
              </span>
              <span>{{t.cerrarsesion}}</span>
            </a>
          </div>
        </div>
      </div>
    </nav><!-- Fin de navbar -->

    <div class="sidebar-container d-flex" [ngClass]="{'mobile-sidebar-open': mobileSidebarOpen}">
      <div class="mobile-sidebar-backdrop noimprimir" *ngIf="mobileSidebarOpen" (click)="closeMobileSidebar()"></div>

      <div id="sidebar" class="sidebar-collapsed noimprimir" *ngIf="!insertado">
        <div class="sidebar-header d-flex justify-content-between">
          <span class="sidebar-brand">
            <span>{{t.modulos}}</span>
          </span>
          <span class="colapse-side-btn sidebar-collapse-btn"  (click)="collapseSidebar()"><i class="fas fa-arrow-left"></i></span>
        </div>
        <div class="dropdown-divider"></div>

        <app-sidebar-search
          #expandedSidebarSearch
          mode="expanded"
          [t]="t"
          [enabled]="logueado && !insertado"
          [mobileSidebarOpen]="mobileSidebarOpen"
          (requestMobileSidebarOpen)="openMobileSidebarForSearch()"
          (resultSelected)="onSidebarSearchResultClick()">
        </app-sidebar-search>

        <!-- Acordeón data-driven: los módulos, sus permisos e ítems provienen de
             SIDEBAR_MENU (ver ./shared/sidebar-menu/sidebar-menu.config.ts). -->
        <div class="accordion" id="accordionExample"><!-- Accordion -->

          <ng-container *ngFor="let modulo of menu">
            <ng-container *ngIf="puedeVer(modulo.permissions)">

              <a href=""
                class="nav-link nav-link-sm sidebar-module-link"
                [ngClass]="modulo.linkModifierClass"
                [id]="'heading' + modulo.accordionId"
                data-toggle="collapse"
                [attr.data-target]="'#collapse' + modulo.accordionId"
                aria-expanded="true"
                [attr.aria-controls]="'collapse' + modulo.accordionId">
                <img [src]="modulo.expandedLogo" alt="" class="sidebar-module-logo" [class.sidebar-module-logo-wide]="modulo.wide">
                <strong *ngIf="modulo.showLabel" class="ml-2">{{ texto(modulo.labelKey, modulo.fallbackLabel) }}</strong>
              </a>

              <div [id]="'collapse' + modulo.accordionId" class="collapse collapse-links" [attr.aria-labelledby]="'heading' + modulo.accordionId" data-parent="#accordionExample">
                <ng-container *ngTemplateOutlet="moduleItems; context: { $implicit: modulo }"></ng-container>
              </div>

            </ng-container>
          </ng-container>

        </div><!-- Fin de accordion -->

      </div>

      <div class="small-sidebar noimprimir" id="small-sidebar" *ngIf="!insertado">
        <span class="colapse-side-btn small-sidebar-toggle"  (click)="collapseSidebar()">
          <i class="fas fa-arrow-right"></i>
        </span>
        <div class="dropdown-divider"></div>

        <app-sidebar-search
          mode="compact"
          [t]="t"
          [enabled]="logueado && !insertado"
          (resultSelected)="onSidebarSearchResultClick()">
        </app-sidebar-search>

        <!-- Sidebar compacto data-driven: mismo origen SIDEBAR_MENU que el acordeón. -->
        <ng-container *ngFor="let modulo of menu">
          <div class="btn-group dropright" *ngIf="puedeVer(modulo.permissions)">
            <span class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [attr.title]="texto(modulo.labelKey, modulo.fallbackLabel)">
              <img [src]="modulo.compactLogo" alt="" class="small-sidebar-module-logo" [class.small-sidebar-module-logo-wide]="modulo.wide">
            </span>
            <div class="dropdown-menu shadow-lg">
              <h5 class="ml-3">{{ texto(modulo.labelKey, modulo.fallbackLabel) }}</h5>
              <ng-container *ngTemplateOutlet="moduleItems; context: { $implicit: modulo }"></ng-container>
            </div>
          </div>
        </ng-container>
      </div><!-- Fin de small-sidebar -->

      <div class="content " (click)="closeMobileSidebar()">
        <div class="content-container" [class.content-container-flush]="isFullBleedRoute">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>

    <!-- <div class="dropdown-divider"></div> -->

  </div>


  <!-- **********************  LINKS DE OPCIONES MENU SIDEBAR ********************** -->
  <!-- Plantilla única de ítems por módulo, alimentada por SIDEBAR_MENU.
       Se reutiliza tanto en el acordeón expandido como en el sidebar compacto. -->
  <ng-template #moduleItems let-modulo>
    <ng-container *ngFor="let seccion of modulo.sections">

      <!-- Sección con encabezado (<details>) -->
      <details *ngIf="seccion.labelKey" class="menu-section" [open]="seccion.open">
        <summary (click)="$event.stopPropagation()">{{ texto(seccion.labelKey, seccion.fallbackLabel) }}</summary>
        <ng-container *ngFor="let item of seccion.items">
          <a *ngIf="puedeVerItem(item)" class="nav-link nav-link-sm" [routerLink]="[item.route]" routerLinkActive="router-link-active"><i class="{{item.icon}} sidebar-item-icon"></i>{{ etiquetaItem(item) }}</a>
        </ng-container>
      </details>

      <!-- Sección plana (sin encabezado) -->
      <ng-container *ngIf="!seccion.labelKey">
        <ng-container *ngFor="let item of seccion.items">
          <a *ngIf="puedeVerItem(item)" class="nav-link nav-link-sm" [routerLink]="[item.route]" routerLinkActive="router-link-active"><i class="{{item.icon}} sidebar-item-icon"></i>{{ etiquetaItem(item) }}</a>
        </ng-container>
      </ng-container>

    </ng-container>
  </ng-template>
